import React, {useCallback, useEffect} from 'react'
import View from './view'
import {Helmet} from 'react-helmet'
import {useAppDispatch} from '../../../redux/configureStore'
import {useAuth} from '../../../components/AuthProvider'
import {
  getStudyGuide,
  saveStudyGuideProgress,
  selectStudyGuide,
} from '../../../redux/studyGuides'
import {useParams} from 'react-router-dom'
import {toggleErrorDialog} from '../../../redux/config'
import {useSelector} from 'react-redux'
import {getOrganizationCourses} from '../../../redux/courses'
import {getReportedExamResults} from '../../../redux/reportExamStatus'

const StudyGuidePage = () => {
  const {studyGuideId} = useParams()
  const auth = useAuth()
  const dispatch = useAppDispatch()

  const studyGuide = useSelector(selectStudyGuide)

  const loadStudyGuide = useCallback(async () => {
    try {
      if (studyGuideId) {
        const {type} = await dispatch(getStudyGuide({auth, studyGuideId}))
        if (type === getStudyGuide.rejected.type) {
          throw new Error('Failed to load study guide')
        } else {
          setTimeout(() => {
            const element = document.getElementById('progress')
            if (element) {
              const offset = 130
              const elementPosition = element.getBoundingClientRect().top
              const offsetPosition = elementPosition + window.scrollY - offset

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
              })
            }
          }, 500)
        }
      }
    } catch (error) {
      await dispatch(
        toggleErrorDialog({
          opened: true,
          error:
            'We were unable to load the study guide, please retry. If issues persist contact our support team',
        }),
      )
    }
  }, [dispatch, auth.isAuthenticated])

  const saveProgress = async (globalAssetId: number, studyDay: number) => {
    const {type} = await dispatch(
      saveStudyGuideProgress({auth, globalAssetId, studyDay}),
    )

    if (type === saveStudyGuideProgress.fulfilled.type) {
      await dispatch(getOrganizationCourses({auth, keepState: true}))
    }
  }

  const loadReports = useCallback(async () => {
    await dispatch(getReportedExamResults({auth}))
  }, [dispatch, auth.isAuthenticated])

  useEffect(() => {
    if (auth.isAuthenticated) {
      loadStudyGuide()
      loadReports()
    }
  }, [loadStudyGuide])

  return (
    <>
      <Helmet>
        {studyGuide ? (
          <title>{`${studyGuide.courseTitle} Guided Study Process | Black Spectacles`}</title>
        ) : (
          <title>{`Guided Study Process | Black Spectacles`}</title>
        )}
      </Helmet>
      <View studyGuide={studyGuide} onSaveProgress={saveProgress} />
    </>
  )
}

export default StudyGuidePage
